var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-empty',{attrs:{"image":"error","description":"个人及事业单位"}}),_c('van-empty',{attrs:{"image":"network","description":"企业"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }